import { render, staticRenderFns } from "./Luxury.vue?vue&type=template&id=467b4637&"
import script from "./Luxury.vue?vue&type=script&lang=js&"
export * from "./Luxury.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports